<template>
  <div class="listen-test-management">
    <section>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="公开课试听" name="first">
          <el-form :inline="true" class="form-style" size="small">
            <el-form-item label="学员姓名">
              <el-input v-model="name" placeholder="请输入学员姓名"></el-input>
            </el-form-item>
            <el-form-item label="家长手机号">
              <el-input
                v-model="name"
                placeholder="请输入家长手机号"
              ></el-input>
            </el-form-item>

            <el-form-item label="时间范围">
              <el-date-picker
                v-model="timeScope"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                placement="bottom-start"
              ></el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-form>

          <el-row>
            <el-col :span="24"
              ><div class="studentlist">
                <openstudentTable
                  :tableData="AuditionStudents"
                ></openstudentTable></div
            ></el-col>
          </el-row>

          <div class="pagination-style">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-size="20"
              layout="total, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="跟班试听" name="second">
          <el-form :inline="true" class="form-style" size="small">
            <el-form-item label="学员姓名:">
              <el-input v-model="name" placeholder="请输入学员姓名"></el-input>
            </el-form-item>
            <el-form-item label="家长手机号:">
              <el-input
                v-model="name"
                placeholder="请输入家长手机号"
              ></el-input>
            </el-form-item>

            <el-form-item label="时间范围:">
              <el-date-picker
                v-model="timeScope"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                placement="bottom-start"
              ></el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-form>

          <el-row>
            <el-col :span="24"
              ><div class="studentlist">
                <openstudentTable
                  :tableData="FormalAuditionStudents"
                ></openstudentTable></div
            ></el-col>
          </el-row>

          <div class="pagination-style">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-size="20"
              layout="total, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </el-tab-pane>

        <!--
        <el-tab-pane label="公开课转化率" name="second">
          <div class="classStatistics" v-if="listenTestStatus === '1'">
            <div class="form-style-open">
              <el-form :inline="true">
                <el-form-item label="试听状态">
                  <el-select v-model="listenTestStatus" style="width: 150px">
                    <el-option label="按班级统计" value="1"></el-option>
                    <el-option label="按教师统计" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="时间范围:">
                  <el-date-picker
                    v-model="timeScope"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="班级名称:">
                  <el-input
                    v-model="name"
                    placeholder="请输入班级名称"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button>重置</el-button>
                  <el-button type="primary">查询</el-button>
                </el-form-item>
              </el-form>
              <div>
                <el-button type="primary">导出</el-button>
              </div>
            </div>
            <div class="table-style">
              <el-table
                :data="tableData"
                border
                :header-cell-style="{ background: '#f5f7fa' }"
              >
                <el-table-column
                  prop="name"
                  label="所属校区"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="phone"
                  label="班级名称"
                  width="180"
                ></el-table-column>
                <el-table-column prop="sex" label="任课老师"></el-table-column>
                <el-table-column
                  prop="status"
                  label="试听人数"
                ></el-table-column>
                <el-table-column
                  prop="class"
                  label="试听成功人数"
                ></el-table-column>
                <el-table-column prop="time" label="转换率"></el-table-column>
              </el-table>
              <div style="margin-top: 30px; text-align: right">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNo"
                  :page-sizes="[100, 200, 300, 400]"
                  :page-size="20"
                  layout="total,prev, pager, next"
                  :total="400"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="teacherStatistics" v-if="listenTestStatus === '2'">
            <div class="form-style-open">
              <el-form :inline="true">
                <el-form-item label="试听状态">
                  <el-select v-model="listenTestStatus" style="width: 150px">
                    <el-option label="按班级统计" value="1"></el-option>
                    <el-option label="按教师统计" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="教师名称:">
                  <el-input
                    v-model="name"
                    placeholder="请输入教师名称"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button>重置</el-button>
                  <el-button type="primary">查询</el-button>
                </el-form-item>
              </el-form>
              <div>
                <el-button type="primary">导出</el-button>
              </div>
            </div>
            <div class="table-style">
              <el-table
                :data="tableData"
                border
                :header-cell-style="{ background: '#f5f7fa' }"
              >
                <el-table-column
                  prop="name"
                  label="任课老师"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="status"
                  label="试听人数"
                ></el-table-column>
                <el-table-column
                  prop="class"
                  label="试听成功人数"
                ></el-table-column>
                <el-table-column prop="time" label="转换率"></el-table-column>
              </el-table>
              <div style="margin-top: 30px; text-align: right">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNo"
                  :page-sizes="[100, 200, 300, 400]"
                  :page-size="20"
                  layout="total, prev, pager, next"
                  :total="400"
                ></el-pagination>
              </div>
            </div>
          </div>
        </el-tab-pane>
-->
      </el-tabs>
    </section>

    <!--公开课转为正式学员-->
    <el-dialog
      width="80%"
      title="公开课转正式"
      :visible.sync="dialogFormVisible1"
    >
      <el-form :model="form" size="small">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <span>北北</span>
        </el-form-item>

        <el-form-item label="试听班级" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择转化的试听班级">
            <el-option label="1班" value="shanghai"></el-option>
            <el-option label="2班" value="beijing"></el-option>
          </el-select>

          <el-tooltip
            class="item"
            effect="dark"
            content="选择转化为正式学员的试听班级"
            placement="top-start"
          >
            <icon style="margin-left: 10px" class="el-icon-question"></icon>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <addformalClassDialog></addformalClassDialog>
        </el-form-item>

        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains"
          :label="'已选班级'"
          :label-width="formLabelWidth"
          :key="domain.key"
          :prop="'domains.' + index + '.value'"
          :rules="{
            message: '班级价格不能为空',
            trigger: 'blur',
          }"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称:Jrcode小分队</span>
            <el-button
              style="margin-left: 10px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
            <br />
            <span>体系名称:Jrcode编程思维</span><br />
            <span>上课老师:大白老师</span><br />
            <span>授课时段:周六 14:00 - 15:30</span><br />
            <span>原价:1999</span>
            <div style="width: 300px">
              <span>现价:</span>
              <el-input
                size="small"
                v-model="domain.value"
                placeholder="请输入现价"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择商品" :label-width="formLabelWidth">
          <addGoods></addGoods>
        </el-form-item>

        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains1"
          :label="'已选商品'"
          :label-width="formLabelWidth"
          :key="domain.key"
          :prop="'domains.' + index + '.value'"
          :rules="{
            message: '商品价格不能为空',
            trigger: 'blur',
          }"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>商品名称:互动编程手柄</span>
            <el-button
              style="margin-left: 10px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
            <br />
            <span>原价:1999</span>
            <div style="width: 300px">
              <span>现价:</span>
              <el-input
                size="small"
                v-model="domain.value"
                placeholder="请输入现价"
              ></el-input>

              <el-input-number
                style="margin-top: 10px"
                size="small"
                v-model="num"
                @change="handleChange"
                :min="1"
                :max="10"
                label="描述文字"
              ></el-input-number>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="订单总额" :label-width="formLabelWidth">
          <span>1980元</span>
        </el-form-item>

        <el-form-item label="备注信息" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible1 = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!--跟班试听转为正式学员-->
    <el-dialog
      width="80%"
      title="跟班试听转正式"
      :visible.sync="dialogFormVisible2"
    >
      <el-form :model="form" size="small">
        <el-form-item label="学员姓名" :label-width="formLabelWidth">
          <span>北北</span>
        </el-form-item>

        <el-form-item label="试听班级" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择转化的试听班级">
            <el-option label="1班" value="shanghai"></el-option>
            <el-option label="2班" value="beijing"></el-option>
          </el-select>

          <el-tooltip
            class="item"
            effect="dark"
            content="选择转化为正式学员的试听班级"
            placement="top-start"
          >
            <icon style="margin-left: 10px" class="el-icon-question"></icon>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <addformalClassDialog></addformalClassDialog>
        </el-form-item>

        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains"
          :label="'已选班级'"
          :label-width="formLabelWidth"
          :key="domain.key"
          :prop="'domains.' + index + '.value'"
          :rules="{
            message: '班级价格不能为空',
            trigger: 'blur',
          }"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>班级名称:Jrcode小分队</span>
            <el-button
              style="margin-left: 10px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
            <br />
            <span>体系名称:Jrcode编程思维</span><br />
            <span>上课老师:大白老师</span><br />
            <span>授课时段:周六 14:00 - 15:30</span><br />
            <span>原价:1999</span>
            <div style="width: 300px">
              <span>现价:</span>
              <el-input
                size="small"
                v-model="domain.value"
                placeholder="请输入现价"
              ></el-input>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="选择商品" :label-width="formLabelWidth">
          <addGoods></addGoods>
        </el-form-item>

        <el-form-item
          v-for="(domain, index) in dynamicValidateForm.domains1"
          :label="'已选商品'"
          :label-width="formLabelWidth"
          :key="domain.key"
          :prop="'domains.' + index + '.value'"
          :rules="{
            message: '商品价格不能为空',
            trigger: 'blur',
          }"
        >
          <div style="background: #f7f8fa; padding: 10px">
            <span>商品名称:互动编程手柄</span>
            <el-button
              style="margin-left: 10px"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
            ></el-button>
            <br />
            <span>原价:1999</span>
            <div style="width: 300px">
              <span>现价:</span>
              <el-input
                size="small"
                v-model="domain.value"
                placeholder="请输入现价"
              ></el-input>

              <el-input-number
                style="margin-top: 10px"
                size="small"
                v-model="num"
                @change="handleChange"
                :min="1"
                :max="10"
                label="描述文字"
              ></el-input-number>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="订单总额" :label-width="formLabelWidth">
          <span>1980元</span>
        </el-form-item>

        <el-form-item label="备注信息" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.desc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible2 = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import addGoods from '@/components/addGoods'
import addformalClassDialog from '@/components/addformalClassDialog'
import openstudentTable from './components/open-student-table'

import {
  getAuditionClassAuditionStudentList,
  getNormalClassAuditionStudentList,
} from '@/api/educational'

export default {
  name: 'listen-test-management',
  components: { addformalClassDialog, addGoods, openstudentTable },
  data() {
    return {
      AuditionStudents: [],
      FormalAuditionStudents: [],

      dynamicValidateForm: {
        domains: [
          {
            value: '',
          },
        ],
        domains1: [
          {
            value: '',
          },
          {
            value: '',
          },
        ],
        email: '',
      },
      gridData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
      ],
      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',
      activeName: 'first',
      name: '',
      status: '全部',
      listenTestStatus: '1',
      timeScope: '',
      tableData: [
        {
          name: '小凯',
          phone: '123****3876',
          sex: '男',
          schoolname: '乐乐宝幼儿园',
          grade: '2',
          status: '试听',
          class: '暂未加入班级',
          time: '2020-07023 19:08',
        },
      ],
      pageNo: 1,
      total: 0,
    }
  },

  mounted() {
    this.getAuditionClassAuditionStudentList()
    this.getNormalClassAuditionStudentList()
  },

  methods: {
    //获得公开课试听学员列表
    getAuditionClassAuditionStudentList() {
      getAuditionClassAuditionStudentList({
        student_name: '',
        nickname: '',
        phone_num: '',
        start_time: '',
        end_time: '',
        page_no: '1',
        page_size: '20',
      }).then((res) => {
        console.log('获得所有试听学员')
        console.log(res)
        this.AuditionStudents = res.student_list
      })
    },

    //获得跟班试听学员列表
    getNormalClassAuditionStudentList() {
      getNormalClassAuditionStudentList({
        student_name: '',
        nickname: '',
        phone_num: '',
        start_time: '',
        end_time: '',
        page_no: '1',
        page_size: '20',
      }).then((res) => {
        console.log('获得所有跟班试听学员')
        console.log(res)
        this.FormalAuditionStudents = res.student_list
      })
    },

    search() {},
    handleClick() {},
    handleSizeChange() {},
    handleCurrentChange() {},
    editStudent() {},
  },
}
</script>

<style lang="scss" scoped>
.listen-test-management {
  background-color: #fff;
  margin: 15px;
  border-radius: 5px;
  section {
    padding: 15px;
  }
  .form-style-open {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
